module.exports = __webpack_public_path__ + "static/mathieu-e0c5b5d04ed83c143568043b0623cfb3.png";